import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateRange, MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectJobCriteria, selectAllSearchedJobsPreviewTotalCount, selectSearchFetchingPreview } from 'src/app/common/store/state/app.state';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBasicData } from 'src/app/public/car/constants/car-basic-data';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { JobCriteria } from '../../models/job-criteria.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-job-search-criteria',
    templateUrl: './job-search-criteria.component.html',
    styleUrls: ['./job-search-criteria.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatSelectModule, MatProgressSpinnerModule, AsyncPipe]
})
export class JobSearchCriteriaComponent implements OnInit{

  disabled = false;
  
  pMin = 0; 
  pMax = 0; 
  step = 1; 
  
  yMin = AppConstants.CAR_YEAR_MIN;
  yMax = new Date().getFullYear();

  showTicks = false;
  
  thumbLabel = true;
  value = 0;

  gearboxesBD = CarBasicData.gearboxes;
  fuelTypesBD = CarBasicData.fuelTypes;
  
  carMakesBD: string [] = [];
  carModelsBD: string [] = [];

  countriesBD: Country [] = [];
  citiesBD: string [] = [];

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;
  selectedDateRange: DateRange<Date>;

  //showCriteriaPanel: boolean = true;
  showCriteriaPanel: boolean = (window.innerWidth > AppConstants.SCREEN_BREAK_L);

  jobCriteria: JobCriteria = new JobCriteria();

  fetchingPreview$: Observable<boolean>;
  previewTotalCount$: Observable<number>;

  jobCriteria$: Observable<JobCriteria>;
  

  //selectedCountryCodes$: Observable<string[]>;
  //selectedCountryCodes: string[] = [];
  selectedCountryCodes: string[] = [];


  countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;

  constructor(
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {
      this.fetchingPreview$ = store.select(selectSearchFetchingPreview);
      this.previewTotalCount$ = store.select(selectAllSearchedJobsPreviewTotalCount);
      this.jobCriteria$ = store.select(selectJobCriteria);
      //this.selectedCountryCodes$ = store.select(selectSelectedCountryCodes);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);

    //this.jobCriteria.startDate = new Date(this.todayDate).toISOString();
    //this.jobCriteria.endDate = new Date(this.tomorrowDate).toISOString();
  
    }

  ngOnInit(): void {

    console.log('dates = '+this.jobCriteria.jobStartDate)

    //this.jobCriteria.priceMin = this.pMin;
    //this.jobCriteria.priceMax = this.pMax;
    //this.jobCriteria.businessLines = [this.selectedBusinessLine!.toString()];
    
    this.carMakesBD = CarBasicData.getMakesBD();
    this.countriesBD = GeneralBasicData.getAllCountries();

    this.jobCriteria$.subscribe(criteria => {

      this.jobCriteria = JSON.parse(JSON.stringify(criteria));
      //this.selectedCountryCodes = this.jobCriteria.countries;
      this.selectedCountryCodes = this.jobCriteria.countries;
      //this.jobCriteria.businessLines = [this.selectedBusinessLine!];
      
      this.updateModelsBD();
      this.updateCitiesBD();

      this.store.dispatch(SearchActions.activitiesPreviewCriteriaSubmit({jobCriteria: JSON.parse(JSON.stringify(this.jobCriteria))}));
   
    });

  }

  updateModelsBD(): void{

    this.carModelsBD = CarBasicData.getModelsBD(this.jobCriteria.makes);
   
  }

  updateCitiesBD(): void{

    //this.citiesBD = GeneralBasicData.getAllCities(this.jobCriteria.countries);
    this.citiesBD = GeneralBasicData.getAllCities(this.selectedCountryCodes);
   
  }

  updateModelsSelector(): void{
    this.jobCriteria.models = [];
    this.updateModelsBD();
  }

  updateCitiesSelector(): void{
    this.jobCriteria.cities = [];
    this.citiesBD = GeneralBasicData.getAllCities(this.jobCriteria.countries);
  }

  onCriteriaChange() {
    console.log(this.jobCriteria);
    this.submitSearchPreview();
  }

  formatSliderLabel(value: any): string {

    return AppFunctions.numberWithSpaces(""+value);
  }

  submitSearchPreview(){

    this.store.dispatch(SearchActions.activitiesPreviewCriteriaSubmit( { jobCriteria: JSON.parse(JSON.stringify(this.jobCriteria)) }));
     
  }

  submitSearchForm(): void {

      let crt = JSON.parse(JSON.stringify(this.jobCriteria));

      crt.pageNumber = 0;

      if(window.innerWidth <= AppConstants.SCREEN_BREAK_L ){
        this.showCriteriaPanel = false;
      }

      this.router.navigate(
        ['/provider/job-search'],
        { queryParams: crt }
      );
    
  }

  resetSearch(): void {

    this.jobCriteria = new JobCriteria();
    let crt = JSON.parse(JSON.stringify(this.jobCriteria));
    this.store.dispatch(SearchActions.activitiesPreviewCriteriaSubmit( { jobCriteria: crt }));
    

  }

  saveAlert(): void {

    let crt: JobCriteria = JSON.parse(JSON.stringify(this.jobCriteria));
    console.log(crt);

    this.store.dispatch(DealerActions.addNewAlertSubmit({ criteria: crt }));
    alert("search will be added to your alerts");

  }

  toggleShowCriteria(): void{
    this.showCriteriaPanel = !this.showCriteriaPanel;
  }

  onResize(event: any) {
    //this.updateShowCriteria();
  }

  updateShowCriteria(){
    if(window.innerWidth > AppConstants.SCREEN_BREAK_L){
      this.showCriteriaPanel = true;
    }
    else{
      this.showCriteriaPanel = false;
    }  
  }

  updateCountries(event: any){

    this.jobCriteria.countries = event.value;
    this.selectedCountryCodes = event.value;
    this.updateCitiesSelector();
    //this.store.dispatch(SearchActions.changeSelectedCountriesSubmit({ countryCodes: event.value}));
    this.onCriteriaChange();
  }


  onSelectedDatesChange(event: any){

    //console.log('hellooo '+event.value);
    if(this.jobCriteria.jobEndDate != null &&  this.jobCriteria.jobEndDate !== ""){
      //console.log('start '+ this.jobCriteria.startDate);
      //console.log('end '+ this.jobCriteria.endDate);
      this.onCriteriaChange();
    }
    
  }

  filterPastDates = (date: Date): boolean => {

    if ( ! (date > this.yesterdayDate) ) {
      return false;
    } 

    return true;
  }

}
